import { render, staticRenderFns } from "./Blanc.vue?vue&type=template&id=2ea51271"
import script from "./Blanc.vue?vue&type=script&lang=js"
export * from "./Blanc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports